import { App, DestinationParams } from '../../types';

const getDestinationParams = (href: string): DestinationParams => {
  const url = new URL(href);

  const destinationHashParam = url.hash.replace('#', '').split('=');
  const destinationSearchParams = url.search.replace('?', '').split('&');
  const networkParam = destinationSearchParams[0].split('=');
  const isReconnect = !!destinationSearchParams[2];
  const app = destinationSearchParams[1] as App;

  const isError = destinationHashParam[0] === 'error';
  const errorParam = { error: isError ? destinationHashParam[1] : null };

  const isDestinationId = destinationHashParam[0] === 'destinationId';
  const destinationIdParam = { destinationId: isDestinationId ? destinationHashParam[1] : null };

  const type = networkParam[1] && networkParam[1] !== 'reconnect' ? networkParam[1] : null;
  const network = networkParam[0];

  return {
    app,
    type,
    network,
    isReconnect,
    ...errorParam,
    ...destinationIdParam
  };
};

export default getDestinationParams;
